import React from 'react'
import { MenuItemType } from '@next-nx/utils/types'
import { Button } from '@next-nx/shared-ui/atoms'
import styles from './SimpleBox.module.sass'


interface Props {
  item: MenuItemType
  className?: string
  editMode?: boolean
}

const SimpleBox = (props: Props) => {

  const { 
    item = undefined,
    className = '',
    editMode = false,
  } = props

  return item ? (
    <div className={`${styles.root} ${className}`}>
      {!!item.name && (
        editMode || (typeof item.name !== 'string')
        ? <div className={styles.title}>{item.name}</div>
        : <p className={styles.title}>{item.name}</p>
      )}
       {!!item.description && (
          editMode || (typeof item.description !== 'string')
          ? <div className={styles.description}>{item.description}</div>
          : <div className={styles.description} dangerouslySetInnerHTML={{ __html: item.description}} />
        )}
      {!!item.url && !!item.ctaLabel && (
        <div className={styles.ctaBox}>
          <Button href={item.url} newPage={item.blank} label={item.ctaLabel} />
        </div>
      )}
    </div>
  ) : <></>
}

export default SimpleBox
